<div class="ion-page" id="side-menu-content" >
  <app-tabs class="ion-page"></app-tabs>
</div>
<ion-menu side="start" contentId="side-menu-content" menuId="side-menu" id="side-menu" swipeGesture="false" [disabled]="true">
  <app-side-menu class="ion-page"></app-side-menu>
</ion-menu>
